/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPayeeDrivers.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/payee-drivers";

export class AutogenModelPayeeDrivers<RowType extends ModelRow> extends Endpoint<RowType, RowPayeeDriversFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPayeeDrivers extends ModelRow<RowPayeeDriversFields> {
	constructor(values?: Partial<RowPayeeDriversFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPayeeDriversFields {
	ach_batch_class_code: string;
	add_fed_to_wh: number;
	add_fed_to_wh_c: string;
	add_fed_to_wh_d: Date;
	add_fed_to_wh_n: number;
	add_fed_to_wh_r: number;
	addl_st_to_whold: number;
	addl_st_to_whold_c: string;
	addl_st_to_whold_d: Date;
	addl_st_to_whold_n: number;
	addl_st_to_whold_r: number;
	address1: string;
	address2: string;
	adp_co_code: string;
	adp_e_no: string;
	birth_date: Date;
	check_address: string;
	check_address2: string;
	check_city: string;
	check_city_st_zip: string;
	check_date: Date;
	check_name: string;
	check_number: string;
	check_st: string;
	check_stub_comment: string;
	check_zip: string;
	city: string;
	city_tax_code: string;
	company_id: string;
	country_id: string;
	county_tax_code: string;
	currency: string;
	dependents: number;
	dependents_c: string;
	dependents_d: Date;
	dependents_n: number;
	dependents_r: number;
	disable_payroll_taxes: string;
	"driver.ace_id": string;
	"driver.address": string;
	"driver.alert": string;
	"driver.allow_trailer_drop": string;
	"driver.avl_as_of_date": Date;
	"driver.avl_drive_hours": number;
	"driver.avl_hours": number;
	"driver.avl_onduty_hours": number;
	"driver.base_term1": string;
	"driver.base_term2": string;
	"driver.base_zip1": string;
	"driver.base_zip2": string;
	"driver.birth_date": Date;
	"driver.bseg": string;
	"driver.can_rehire": string;
	"driver.capcreat_filter": string;
	"driver.cb": string;
	"driver.cell_phone": string;
	"driver.chain_pref_1": string;
	"driver.chain_pref_1_value": number;
	"driver.chain_pref_2": string;
	"driver.chain_pref_2_value": number;
	"driver.choice_allocation": string;
	"driver.choice_commodity": string;
	"driver.choice_commodity_exclude": string;
	"driver.choice_customer": string;
	"driver.choice_equip_type": string;
	"driver.choice_exclude_hazmat": string;
	"driver.choice_order_type": string;
	"driver.choice_priority1": string;
	"driver.choice_priority1_value": number;
	"driver.choice_priority2": string;
	"driver.choice_priority2_value": number;
	"driver.choice_revenue": string;
	"driver.choice_review_dt": Date;
	"driver.citizen": string;
	"driver.citizen_country": string;
	"driver.city": string;
	"driver.city_id": number;
	"driver.cmove": string;
	"driver.company_id": string;
	"driver.country_hos_rules": string;
	"driver.country_id": string;
	"driver.currenteqpgrpid": string;
	"driver.ded_rqmt_type": string;
	"driver.ded_type": string;
	"driver.disable_driver_choice": string;
	"driver.disable_feasibility": string;
	"driver.disable_remote_access": string;
	"driver.doubles_certified": string;
	"driver.dri_uid": number;
	"driver.drvr_class": string;
	"driver.ds_model_flag": string;
	"driver.eld_exempt_reason_id": string;
	"driver.email": string;
	"driver.emrg_response_date": Date;
	"driver.enable_driver_app": string;
	"driver.enable_load_choice": string;
	"driver.end_status_date": Date;
	"driver.enginedata_pwd": string;
	"driver.equipment_type_id": string;
	"driver.event_date": Date;
	"driver.event_status": string;
	"driver.exclude_allocation": string;
	"driver.exclude_commodity": string;
	"driver.exclude_customer": string;
	"driver.exclude_equip_type": string;
	"driver.exclude_feasibility": string;
	"driver.exclude_order_type": string;
	"driver.exclude_revenue": string;
	"driver.experience": string;
	"driver.first_name": string;
	"driver.fleet_manager": string;
	"driver.fmcsa_clearinghouse_date": Date;
	"driver.group_id": string;
	"driver.hazmat_certified": string;
	"driver.hazmat_date": Date;
	"driver.hire_date": Date;
	"driver.hm126c_date": Date;
	"driver.home_duration": number;
	"driver.home_location_id": string;
	"driver.id": string;
	"driver.is_active": string;
	"driver.last_34_hour_start_date": Date;
	"driver.last_break_date": Date;
	"driver.last_home_date": Date;
	"driver.last_review_date": Date;
	"driver.latitude": number;
	"driver.license_country": string;
	"driver.license_date": Date;
	"driver.license_no": string;
	"driver.license_state": string;
	"driver.logbook_required": string;
	"driver.longitude": number;
	"driver.manual_pta_update": string;
	"driver.maryland_perm_date": Date;
	"driver.max_dispatches": number;
	"driver.max_dist_loc1": number;
	"driver.max_dist_loc2": number;
	"driver.max_mi_per_day": number;
	"driver.mc_login": string;
	"driver.mc_unit_password": string;
	"driver.medical_cert_exempt": string;
	"driver.medical_cert_expire": Date;
	"driver.model_flag": string;
	"driver.mpw_driver_contact_method": string;
	"driver.mpw_driver_high": number;
	"driver.mpw_driver_low": number;
	"driver.mpw_exclude": string;
	"driver.mpw_last_contact": Date;
	"driver.mpw_num_attempts": number;
	"driver.mpw_num_orders": number;
	"driver.mvr_date": Date;
	"driver.name": string;
	"driver.name_mid_initial": string;
	"driver.name_of_spouse": string;
	"driver.next_home_date": Date;
	"driver.num_complaints": number;
	"driver.pager": string;
	"driver.passport": string;
	"driver.payee_id": string;
	"driver.personal_conveyance": string;
	"driver.phone": string;
	"driver.physical_date": Date;
	"driver.planning_comment": string;
	"driver.preferred_days_out": number;
	"driver.prev_code": string;
	"driver.primary_agency": string;
	"driver.proximity_card": string;
	"driver.pta_date": Date;
	"driver.race": string;
	"driver.reason_for_leaving": string;
	"driver.record_pta": string;
	"driver.remark": string;
	"driver.reporting_status": string;
	"driver.return_home_flag": string;
	"driver.route_through_term": string;
	"driver.safety_meet_date": Date;
	"driver.safety_topic": string;
	"driver.security_date": Date;
	"driver.sex": string;
	"driver.shuttle_capable": string;
	"driver.site_id": string;
	"driver.social_security_no": string;
	"driver.speed": number;
	"driver.start_status_date": Date;
	"driver.state": string;
	"driver.status_code": string;
	"driver.stop_pta_update": string;
	"driver.tanks_endorsement": string;
	"driver.team_status": string;
	"driver.tenstreet_id": string;
	"driver.termination_date": Date;
	"driver.tractor_id": string;
	"driver.trainee": string;
	"driver.type_of": string;
	"driver.violation_comment": string;
	"driver.yard_move": string;
	"driver.zip": string;
	"driver_item.company_id": string;
	"driver_item.equipment_group_id": string;
	"driver_item.equipment_id": string;
	"driver_item.equipment_type_id": string;
	"driver_item.id": string;
	"driver_item.trailer_dropped": string;
	"driver_item.type_sequence": number;
	eft_first_name: string;
	eft_individual: string;
	eft_last_name: string;
	eft_middle_initial: string;
	email: string;
	email_summary: string;
	enable_carrier_app: string;
	"equipment_group.company_id": string;
	"equipment_group.currentmovement_id": string;
	"equipment_group.id": string;
	exempt_from_fed: string;
	extra_withholdings: number;
	extra_withholdings_c: string;
	extra_withholdings_d: Date;
	extra_withholdings_n: number;
	extra_withholdings_r: number;
	fed_amt_to_whold: number;
	fed_amt_to_whold_c: string;
	fed_amt_to_whold_d: Date;
	fed_amt_to_whold_n: number;
	fed_amt_to_whold_r: number;
	fed_exemptions: number;
	fed_marital_status: string;
	freeze_pay: string;
	freight_matching_override: string;
	gp_exclude: string;
	gp_exported: Date;
	hire_date: Date;
	holiday_hours_pd: number;
	id: string;
	last_raise_date: Date;
	legal_name: string;
	load_booking_eligible: string;
	loadpay_contact_phone: string;
	multiple_jobs: string;
	name: string;
	non_office_emp: string;
	office_employee: string;
	other_deductions: number;
	other_deductions_c: string;
	other_deductions_d: Date;
	other_deductions_n: number;
	other_deductions_r: number;
	other_income: number;
	other_income_c: string;
	other_income_d: Date;
	other_income_n: number;
	other_income_r: number;
	overtime_hours_pd: number;
	payment_method: string;
	phone_number: string;
	posted_check_date: Date;
	prev_code: string;
	primary_agency: string;
	regular_hours_pd: number;
	remarks: string;
	settlement_status: string;
	sick_hours_pd: number;
	social_security_no: string;
	st_amt_to_whold: number;
	st_amt_to_whold_c: string;
	st_amt_to_whold_d: Date;
	st_amt_to_whold_n: number;
	st_amt_to_whold_r: number;
	st_marital_status: string;
	state: string;
	state_exemptions: number;
	state_tax_code: string;
	status: string;
	sui_tax_code: string;
	tax_table_city_aux: number;
	tax_table_city_misc: number;
	tax_table_county_aux: number;
	tax_table_county_misc: number;
	tax_table_fit_aux: number;
	tax_table_fit_misc: number;
	tax_table_st_aux: number;
	tax_table_st_misc: number;
	tax_table_sui_aux: number;
	tax_table_sui_misc: number;
	termination_date: Date;
	"tractor.a_maint_hub": number;
	"tractor.ace_id": string;
	"tractor.allow_relay": string;
	"tractor.assign_date": Date;
	"tractor.avail_date": Date;
	"tractor.axle_number_code": string;
	"tractor.b_maint_hub": number;
	"tractor.city_id": number;
	"tractor.comments": string;
	"tractor.company_id": string;
	"tractor.current_hub": number;
	"tractor.current_site": string;
	"tractor.current_stop_id": string;
	"tractor.currenteqpgrpid": string;
	"tractor.daily_dist_goal": number;
	"tractor.daily_rev_goal": number;
	"tractor.daily_rev_goal_c": string;
	"tractor.daily_rev_goal_d": Date;
	"tractor.daily_rev_goal_n": number;
	"tractor.daily_rev_goal_r": number;
	"tractor.dash_hub_delta": number;
	"tractor.dispatch_opt": string;
	"tractor.dispatcher": string;
	"tractor.dispatcher_login": string;
	"tractor.dot_number": string;
	"tractor.driver1_id": string;
	"tractor.driver2_id": string;
	"tractor.exclude_from_trip_mgt": string;
	"tractor.exclude_fuel_fueltax": string;
	"tractor.exclude_fueltax": string;
	"tractor.fill_hub": number;
	"tractor.fleet_id": string;
	"tractor.floor_space": number;
	"tractor.force_assign": string;
	"tractor.fuel_capacity": number;
	"tractor.fuel_level": number;
	"tractor.fuel_type_code": string;
	"tractor.gross_veh_weight": number;
	"tractor.gross_veh_weight_um": string;
	"tractor.h_insurance_amount": number;
	"tractor.h_insurance_amount_c": string;
	"tractor.h_insurance_amount_d": Date;
	"tractor.h_insurance_amount_n": number;
	"tractor.h_insurance_amount_r": number;
	"tractor.h_insurance_date": Date;
	"tractor.hub_change": number;
	"tractor.hub_change_date": Date;
	"tractor.hub_new": number;
	"tractor.hub_required": string;
	"tractor.id": string;
	"tractor.inservice_date": Date;
	"tractor.inspection_date": Date;
	"tractor.insurance_account": string;
	"tractor.insurance_amount": number;
	"tractor.insurance_amount_c": string;
	"tractor.insurance_amount_d": Date;
	"tractor.insurance_amount_n": number;
	"tractor.insurance_amount_r": number;
	"tractor.insurance_date": Date;
	"tractor.insurance_name": string;
	"tractor.irp_code": string;
	"tractor.is_local": string;
	"tractor.liability_end_dt": Date;
	"tractor.liability_insured": string;
	"tractor.liability_start_dt": Date;
	"tractor.loadboard": string;
	"tractor.loc_uid": number;
	"tractor.maintenance_date": Date;
	"tractor.make": string;
	"tractor.model": string;
	"tractor.model_year": string;
	"tractor.oil_hub": number;
	"tractor.outservice_date": Date;
	"tractor.owner": string;
	"tractor.pay_owner": string;
	"tractor.phantom": string;
	"tractor.planning_comment": string;
	"tractor.pnn_avail_frm_city": string;
	"tractor.pnn_avail_frm_st": string;
	"tractor.pnn_avail_frm_zip": string;
	"tractor.pnn_avail_to_city": string;
	"tractor.pnn_avail_to_st": string;
	"tractor.pnn_avail_to_type": string;
	"tractor.pnn_comment": string;
	"tractor.pnn_comment2": string;
	"tractor.pnn_cubicfeet": number;
	"tractor.pnn_decklength": number;
	"tractor.pnn_enhancements": string;
	"tractor.pnn_loadweight": number;
	"tractor.pnn_ovr_callback": string;
	"tractor.pnn_post_type": string;
	"tractor.posted_stop_id": string;
	"tractor.primary_agency": string;
	"tractor.promise_date": Date;
	"tractor.purchase_date": Date;
	"tractor.pwu_uid": number;
	"tractor.serial_number": string;
	"tractor.service_status": string;
	"tractor.status": string;
	"tractor.swap": string;
	"tractor.tag": string;
	"tractor.tag_expire_date": Date;
	"tractor.tag_state": string;
	"tractor.transponder": string;
	"tractor.type_of": string;
	"tractor.video_safety_control_id": string;
	"tractor.weight": number;
	"tractor.weight_reg_code": string;
	"tractor.weight_um": string;
	"tractor.work_order": string;
	"tractor.work_order_status": string;
	"tractor.zmit_fuelopt": string;
	"tractor_item.company_id": string;
	"tractor_item.equipment_group_id": string;
	"tractor_item.equipment_id": string;
	"tractor_item.equipment_type_id": string;
	"tractor_item.id": string;
	"tractor_item.trailer_dropped": string;
	"tractor_item.type_sequence": number;
	vacation_hours_pd: number;
	vm_part_update: string;
	w4_status: string;
	wf_queue: number;
	ytd_holiday_hrs: number;
	ytd_overtime_hrs: number;
	ytd_reg_hrs_paid: number;
	ytd_sick_hrs_paid: number;
	ytd_vacation_hrs: number;
	zip_code: string;
}

